/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
import Divider from "@mui/material/Divider";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from '@mui/material/Typography';

function ProgressIndicators({ instance }) {
  if (!instance) {
    return null;
  }

  const handleStatusLabel = (status) => {
    if (!status) {
      return 'Loading...';
    }

    const label = status.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

    return label;
  }

  const handleStatusColor = (status) => {
    switch (status) {
      case 'not_started':
        return 'primary';
      case 'complete':
        return 'success';
      default:
        return 'secondary';
    }
  }


  return (
    <div className="w-full flex grid grid-cols-2 gap-16">
      <div className="flex flex-col">
        <Typography className="text-sm" color="text.secondary">
          Storyboard
        </Typography>
        <Typography className="font-medium text-md">
          {handleStatusLabel(instance?.status?.development)}
        </Typography>
        <LinearProgress
          variant="determinate"
          className="mt-4"
          color={handleStatusColor(instance?.status?.development)}
          value={instance?.progress?.development || 0}
        />
      </div>
      <div className="flex flex-col">
        <Typography className="text-sm" color="text.secondary">
          Production
        </Typography>
        <Typography className="font-medium text-md">
          {handleStatusLabel(instance?.status?.production)}
        </Typography>
        <LinearProgress
          variant="determinate"
          className="mt-4"
          color={handleStatusColor(instance?.status?.production)}
          value={instance?.progress?.production || 0}
        />
      </div>
    </div>
  );
}

export default ProgressIndicators;
